import { render, staticRenderFns } from "./gameResultSlotsExportFull.vue?vue&type=template&id=734c3052&lang=pug"
import script from "./gameResultSlotsExportFull.vue?vue&type=script&lang=js"
export * from "./gameResultSlotsExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports